const DEFAULT_EMAIL_AUTH_ORIGIN = 'https://printboard.io'

const normalizeOrigin = (value: string) => value.trim().replace(/\/+$/, '')

const isLocalOrigin = (origin: string) => {
  try {
    const parsed = new URL(origin)
    return (
      parsed.hostname === 'localhost' ||
      parsed.hostname === '127.0.0.1' ||
      parsed.hostname === '0.0.0.0'
    )
  } catch {
    return false
  }
}

export const resolveEmailAuthRedirectOrigin = ({
  currentOrigin,
  configuredOrigin,
}: {
  currentOrigin: string
  configuredOrigin?: string | null
}) => {
  const configured = configuredOrigin ? normalizeOrigin(configuredOrigin) : null
  if (configured) return configured

  const normalizedCurrentOrigin = normalizeOrigin(currentOrigin)
  if (isLocalOrigin(normalizedCurrentOrigin)) {
    return DEFAULT_EMAIL_AUTH_ORIGIN
  }

  return normalizedCurrentOrigin
}

export const buildEmailAuthRedirectUrl = ({
  currentOrigin,
  path,
  configuredOrigin,
}: {
  currentOrigin: string
  path: string
  configuredOrigin?: string | null
}) => {
  const origin = resolveEmailAuthRedirectOrigin({
    currentOrigin,
    configuredOrigin,
  })

  return `${origin}${path.startsWith('/') ? path : `/${path}`}`
}
